import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { SxProps, Theme } from "@mui/material/styles";

import { ReactNode } from "react";
import { UITooltip } from "../UITooltip";

interface TitleWithTooltipInfoProps {
  tooltipTitle: ReactNode;
  chartTitle: string;
  placement?: "top" | "bottom" | "left" | "right";
  showInfoIcon?: boolean;
  sx?: {
    tooltip?: SxProps<Theme>;
    /** Styles for the title typography */
    title?: SxProps<Theme>;
    /** Styles for the info icon */
    icon?: SxProps<Theme>;
  };
}

export const TitleWithTooltipInfo = ({
  tooltipTitle,
  chartTitle,
  placement = "top",
  showInfoIcon = false,
  sx = {},
}: TitleWithTooltipInfoProps) => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={1}
      sx={{
        width: "fit-content",
        maxWidth: "100%",
        minWidth: 0,
        flexShrink: 1,
        mr: 1,
      }}
    >
      <Typography
        noWrap
        sx={{
          fontSize: "20px",
          fontWeight: "bold",
          minWidth: 0,
          overflow: "hidden",
          textOverflow: "ellipsis",
          ...sx.title,
        }}
      >
        {chartTitle}
      </Typography>
      <UITooltip title={tooltipTitle} placement={placement} sx={sx.tooltip}>
        <InfoOutlinedIcon
          sx={{
            fontSize: 24,
            color: "#343c4391",
            flexShrink: 0,
            opacity: showInfoIcon ? 1 : 0,
            transition: "opacity 0.2s ease-in-out",
            visibility: showInfoIcon ? "visible" : "hidden",
            ...sx.icon,
          }}
        />
      </UITooltip>
    </Stack>
  );
};
